import React, { useState, useEffect } from 'react';
import { message, Form } from 'antd';
import Card, { CardEdit } from 'components/Card/Card';
import { useEditCard } from 'components/Card/useEditCard';
import TabularList from 'components/TabularList/TabularList';
import providerService from 'services/providers.service';
import Switch from 'components/Switch/Switch';

const IncludedCosts = ({ application, isEditable = false }) => {
  const [localApplication, setLocalApplication] = useState(application);
  const [includedCostsForm] = Form.useForm();

  useEffect(() => {
    setLocalApplication(application);
  }, [application]);

  const { isEditing: isEditingIncludedCosts, editProps: includedCostsEditProps } = useEditCard({
    id: 'included-costs',
    onEditStart: () =>
      includedCostsForm.setFieldsValue({
        lunchIncluded: localApplication?.lunchIncluded,
        formulaFeeIncluded: localApplication?.formulaFeeIncluded,
      }),
    onSave: async () => {
      await includedCostsForm.validateFields();
      const values = includedCostsForm.getFieldsValue();
      const updatedApplication = await providerService.updateApplication(application.id, {
        ...localApplication,
        lunchIncluded: values.lunchIncluded,
        formulaFeeIncluded: values.formulaFeeIncluded,
      });
      setLocalApplication(updatedApplication);
      includedCostsForm.resetFields();
      message.success('Included costs updated');
    },
    onDiscard: () => includedCostsForm.resetFields(),
  });

  return (
    <Card
      title="Included Costs"
      extra={isEditable ? <CardEdit {...includedCostsEditProps} /> : null}
      noBodyPadding
      stickyHeader
    >
      <Form form={includedCostsForm} disabled={includedCostsEditProps.loading}>
        <TabularList
          indented
          data={[
            {
              title: 'Lunch included in tuition',
              value: isEditingIncludedCosts ? (
                <Form.Item name="lunchIncluded" className="mb-0" valuePropName="checked">
                  <Switch checkedChildren="Yes" unCheckedChildren="No" />
                </Form.Item>
              ) : localApplication?.lunchIncluded ? (
                'Yes'
              ) : (
                'No'
              ),
              titleRequired: true,
            },
            {
              title: 'Formula included in tuition for infants (6 weeks–12 months)',
              value: isEditingIncludedCosts ? (
                <Form.Item name="formulaFeeIncluded" className="mb-0" valuePropName="checked">
                  <Switch checkedChildren="Yes" unCheckedChildren="No" />
                </Form.Item>
              ) : localApplication?.formulaFeeIncluded ? (
                'Yes'
              ) : (
                'No'
              ),
              titleRequired: true,
            },
          ]}
        />
      </Form>
    </Card>
  );
};

export default IncludedCosts;
